module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('card-header', {
    attrs: {
      "titulo": "Avaliações Periódicas de Desempenho"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraMensagemDeSemAvaliacao),
      expression: "mostraMensagemDeSemAvaliacao"
    }],
    staticClass: "alert alert-danger",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle fa-lg"
  }), _vm._v("\n                    Caso não veja sua avaliação do ano de\n                  " + _vm._s(_vm.anoDaAvaliacaoAtual) + ", favor entrar em contato com o\n                  telefone 3213-7166 (DEGEPAT).\n                ")]), _vm._v(" "), _c('table-loader', {
    attrs: {
      "carregando": _vm.carregando
    }
  }, [(_vm.anosAvaliados.length == 0) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Ainda não foram\n                    geradas avaliações para o seu registro.\n                  ")]) : _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Ano da Avaliação")]), _vm._v(" "), (_vm.ehAvaliador) ? _c('th', [_vm._v("Minha Avaliação")]) : _c('th', [_vm._v("Avaliação")]), _vm._v(" "), (_vm.ehAvaliador) ? _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("\n                          Avaliados Pendentes\n                        ")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.avaliacoesOrdenadas), function(avaliacao) {
    return _c('tr', {
      key: avaliacao.id,
      class: _vm.statusDaLinhaDaTabela(avaliacao)
    }, [_c('td', [_vm._v(_vm._s(avaliacao.ano))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusDaAvaliacao(avaliacao)) + "\n                        ")]), _vm._v(" "), (_vm.ehAvaliador) ? _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                          " + _vm._s(_vm.quantidadeDeAvaliacoesPorAvaliador(avaliacao)) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "td-btns td-btns-alone"
    }, [(_vm.ehAvaliador) ? _c('div', [_c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          _vm.condicionalDoBotaoDeAvaliador(avaliacao)
        ),
        expression: "\n                                condicionalDoBotaoDeAvaliador(avaliacao)\n                              "
      }, {
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Editar'),
        expression: "'Editar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": _vm.statusDoBotao(avaliacao),
        "icone": "editar-tabela"
      },
      on: {
        "clicado": function($event) {
          return _vm.editaAvaliacao(_vm.funcionario.id, avaliacao)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          !_vm.condicionalDoBotaoDeAvaliador(avaliacao)
        ),
        expression: "\n                                !condicionalDoBotaoDeAvaliador(avaliacao)\n                              "
      }, {
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Visualizar'),
        expression: "'Visualizar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "visualizar"
      },
      on: {
        "clicado": function($event) {
          return _vm.editaAvaliacao(_vm.funcionario.id, avaliacao)
        }
      }
    })], 1) : _c('div', [_c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          _vm.condicionalDoBotaoComum(avaliacao, true)
        ),
        expression: "\n                                condicionalDoBotaoComum(avaliacao, true)\n                              "
      }, {
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Editar'),
        expression: "'Editar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": _vm.statusDoBotao(avaliacao),
        "icone": "editar-tabela"
      },
      on: {
        "clicado": function($event) {
          return _vm.editaAvaliacao(_vm.funcionario.id, avaliacao)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          _vm.condicionalDoBotaoComum(avaliacao, false)
        ),
        expression: "\n                                condicionalDoBotaoComum(avaliacao, false)\n                              "
      }, {
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Visualizar'),
        expression: "'Visualizar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "visualizar"
      },
      on: {
        "clicado": function($event) {
          return _vm.editaAvaliacao(_vm.funcionario.id, avaliacao)
        }
      }
    })], 1)])])
  }), 0)])])], 1)], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23a3c44e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/avaliacao/index.vue
// module id = P/VR
// module chunks = 5